import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/common/button/Button";
import { Form, Formik } from "formik";
import { postApi } from "../../../services/api/globalApi";
import {
  successMessage,
  warningMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import Select from "../../../components/common/inputs/Select";
import ImagesModal from "../../../components/common/modals/imgaes-modal/ImagesModal";
import { publicImageProps } from "../../../services/config";
import { PiXFill } from "react-icons/pi";

function LearnResultGallery({ data }) {
  const formHandler = async (values, {}) => {
    const path = "admin/publicFieldsForFrontUis";
    const body = {
      learnResultGallery: {
        value: images,
        isActive: values?.isActive,
      },
    };
    try {
      await postApi({ path, body });
      successMessage("عکس های نتایج با موفقیت بروزرسانی شد.");
    } catch (error) {
      console.log(error);
    }
  };

  const imagesModal = useRef();
  const [images, setImages] = useState([]);

  const selectedImages = (item) => {
    const isExist = images.filter((items) => {
      return items === item?.name;
    });
    if (isExist?.length) {
      warningMessage("این عکس از قبل وجود دارد");
    } else {
      setImages((prev) => [...prev, item.name]);
      successMessage("عکس اضافه شد.");
    }
  };

  const deleteImg = (item) => {
    const newImages = images.filter((items) => {
      return items !== item;
    });
    setImages(newImages);
  };

  useEffect(() => {
    if (data?.value?.length) {
      setImages(data?.value);
    }
  }, [data]);

  return (
    <>
      <div className="w-full py-4 px-4 border-r border-l">
        <Formik
          enableReinitialize
          initialValues={{
            isActive: data?.isActive || false,
          }}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Select
                  name="isActive"
                  value={formik.values["isActive"] ? "true" : "false"}
                  onChange={(e) => {
                    formik.setFieldValue("isActive", e.target.value === "true");
                  }}
                  placeholder="فعال باشه؟"
                  label="فعال باشه؟"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>
                <div className="mt-8">
                  <Button
                    onClick={() => imagesModal.current?.showModal()}
                    text={"افزودن عکس"}
                    color={"primary"}
                    type="button"
                  />
                </div>
              </div>
              {images?.length ? (
                <div className="w-full">
                  <h3>عکس های نتایج</h3>
                  <div className="grid grid-cols-4 gap-4 mt-6">
                    {images.map((item) => {
                      return (
                        <div className="relative">
                          <PiXFill
                            onClick={() => deleteImg(item)}
                            size={30}
                            className="text-red-400 transition-all hover:text-red-600 cursor-pointer absolute top-0 right-0"
                          />
                          <img
                            className="h-auto max-w-full rounded-lg"
                            {...publicImageProps(item, { variant: "medium_" })}
                            alt=""
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="w-full flex items-cetnter justify-center gap-4 shadow rounded-lg py-10 mt-4">
                  <p>شما هنوز هیچ عکسی اضافه نکرده اید</p>
                </div>
              )}
              <div className="flex flex-col mt-8 gap-y-2">
                <div className="">
                  <Button text={"بروزرسانی اطلاعات"} color={"success"} />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </>
  );
}

export default LearnResultGallery;
